import { NoteType } from '@museflow-ai/opensheetmusicdisplay';
import Scheduler from './Scheduler';

export default class Scheduler2 extends Scheduler {
  unpauseTicks = (
    bpm: number,
    countInMeasures: number,
    startMeasure: number,
    tickNoteType: NoteType,
    absoluteTiming: boolean = false,
  ) => {
    console.debug('scheduler: unpausing');
    if (!this.timeKeeper.isPaused() || this.handlingPauseOrUnpause) {
      return;
    }
    this.handlingPauseOrUnpause = true;

    // Load metronome audio samples
    // await this.initialize_samples()

    const elapsedTicks = this.timeKeeper?.calculateElapsedTicks();
    const numberOfTicksPerMeasure = this.timeKeeper.getTicksPerMeasure();

    let lastCompleteMeasure = Math.floor(elapsedTicks / numberOfTicksPerMeasure);
    if (isNaN(lastCompleteMeasure) || lastCompleteMeasure < 0) {
      lastCompleteMeasure = this.countInMeasures;
    }
    const measureOffset = absoluteTiming ? startMeasure : this.lastPauseMeasure;
    console.debug('scheduler measure offset: ', measureOffset, startMeasure);
    this.timeKeeper.unpause(bpm, 0, measureOffset, tickNoteType);

    this.lastScheduledBeat = -10000;
    this.scheduleMetronomeAudio();

    // Let any unpause callbacks run their logic before we kick the ticks loop and audio context back to life.
    for (const unpauseCb of this.unpauseFns) {
      unpauseCb(
        this.timeKeeper?.calculateElapsedTicks(),
        this.timeKeeper?.getPlaybackStartTicks(),
        this.timeKeeper?.getTicksPerMeasure(),
      );
    }

    // Start (or restart) the tick interval loop.
    this.tickIntervalFn = this._startTickIntervalLoop();
    this.handlingPauseOrUnpause = false;
  };
}
